import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight} from '@fortawesome/free-solid-svg-icons'



export default function JisPrompt(props) {


  return (
   <div>
   {props.open && <div className={ "dialog-box open" }>
                    
                   
                    <div className="wrapper">
                    <h3>{props.title} </h3>
                    <div className="main" style={{padding:16}}>
                     
                        {props.children} 
                        <div className="btns">
                            
                            <button className='red' onClick={props.onCancel}>No <FontAwesomeIcon icon={faArrowRight} /></button>
                            <button className='red' onClick={props.onOk}>Yes <FontAwesomeIcon icon={faArrowRight} /></button>
                        </div>  
                    </div>
                </div>
                
                
            </div>} 
  
   </div> 
  );
}
